import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=117f5fe7"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('117f5fe7')) {
      api.createRecord('117f5fe7', component.options)
    } else {
      api.reload('117f5fe7', component.options)
    }
    module.hot.accept("./Sidebar.vue?vue&type=template&id=117f5fe7", function () {
      api.rerender('117f5fe7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/Sidebar.vue"
export default component.exports